export const CONNECTIONS_PATH = "/context-hub/connected-data/connections";

export function connectionPath(syncId: string): string {
  return `${CONNECTIONS_PATH}/${syncId}`;
}

/** The surface that sent the user to the connection flow, for analytics. */
export type ConnectionFlowSource = "destination_card";

export function newConnectionForDestinationPath({
  destinationId,
  destinationType,
  source,
}: {
  destinationId: string;
  destinationType: string;
  source: ConnectionFlowSource;
}): string {
  const params = new URLSearchParams({
    destinationId,
    destinationType,
    source,
  });
  return `${CONNECTIONS_PATH}/new?${params}`;
}

export const CONNECTED_DATA_CRUMB = {
  label: "Connected data",
  link: "/context-hub/connected-data/integrations",
};
